import { Button } from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

import type { InconsistencyModalItemBase } from '../../models';
import { useVerificationOfPayeeTranslations } from '../../translations/translations';
import { InconsistencyModal } from '../InconsistencyModal';

type Props<T extends InconsistencyModalItemBase> = {
  isOpen: boolean;
  items: T[];
  renderItemSummary: (item: T) => ReactNode;
  onCancel: () => void;
  onContinue: () => void;
  onClose: () => void;
};

export const ConfirmInconsistencyModal = <
  T extends InconsistencyModalItemBase,
>({
  isOpen,
  items,
  renderItemSummary,
  onCancel,
  onContinue,
  onClose,
}: Props<T>) => {
  const { t } = useVerificationOfPayeeTranslations();

  const buttons = [
    <Button
      key="cancel"
      text={t('inconsistencyModal.confirm.cancel')}
      variant="secondaryNeutral"
      onClick={onCancel}
    />,
    <Button
      key="continue"
      text={t('inconsistencyModal.confirm.continue')}
      variant="primaryBrand"
      onClick={onContinue}
    />,
  ];
  return (
    <InconsistencyModal<T>
      buttons={buttons}
      isOpen={isOpen}
      items={items}
      labels={{
        titleLabel: t('inconsistencyModal.title'),
        descriptionLabel: t('inconsistencyModal.confirm.description'),
      }}
      renderItemSummary={renderItemSummary}
      onClose={onClose}
    />
  );
};
